import Tracker from "../../../../../../prop-trackers/tracker.js";
import ValueTracker from "../../../../../../prop-trackers/value-tracker.js";
import { Mapper, ValueMapper } from "../../../../../../prop-tracker-utils/mapper.js";
import ConsumingDictMux from "../../../../../../prop-tracker-utils/consuming-dict-mux.js";
import SinglePropChainTracker from "../../../../../../prop-tracker-utils/single-prop-chain-tracker.js";

class ObjectAnimsGenerator extends Tracker {
    constructor(rootAnimTracker, objectRootTracker, evtCtx) {
        super();

        this._rootAnimMapper = new Mapper(rootAnimTracker, (key) => new ObjectAnimMapper(evtCtx));
        this._objAnimMux = new ConsumingDictMux(this._rootAnimMapper, objectRootTracker);

        const needsUpdate = () => this.protected_needsUpdate();
        this._objAnimMux.listenNeedsUpdate(needsUpdate);
    }

    protected_startUpdate() {
        return this._objAnimMux.startUpdate();
    }

    protected_finishUpdate() {
        return this._objAnimMux.finishUpdate();
    }
}

class ObjectAnimMapper extends ValueMapper {
    constructor(evtCtx) {
        super();

        this._animUuidTracker = new SinglePropChainTracker(evtCtx);
        this._outputTracker = new ValueTracker();

        const needsUpdate = () => this.protected_needsUpdate();
        this._animUuidTracker.listenNeedsUpdate(needsUpdate);
    }

    setValue(data) {
        this._animUuidTracker.track(data, ["animation", "uuid"]);
    }

    deleteValue() {
        this._animUuidTracker.track();
    }

    protected_startUpdate() {
        this._animUuidTracker.updateIfNeeded(({ prop: { newValue } }) => {
            if (newValue) {
                this._outputTracker.setValue(newValue);
            } else {
                this._outputTracker.deleteValue();
            }
        });

        return this._outputTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._outputTracker.finishUpdate();
    }
}

export default ObjectAnimsGenerator;
